/**
 * @generated SignedSource<<a480fcdb8ed559db0b8d63c32dfdabc6>>
 * @relayHash 6a9537e4831ca05890204d59cb7480ef
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6a9537e4831ca05890204d59cb7480ef

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssuesAndPullRequestsCountSecondaryQuery$variables = {
  nodes: ReadonlyArray<string>;
};
export type IssuesAndPullRequestsCountSecondaryQuery$data = {
  readonly nodes: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"IssuesAndPullRequestsCount">;
  } | null | undefined>;
};
export type IssuesAndPullRequestsCountSecondaryQuery = {
  response: IssuesAndPullRequestsCountSecondaryQuery$data;
  variables: IssuesAndPullRequestsCountSecondaryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "nodes"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "ids",
    "variableName": "nodes"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  {
    "kind": "Literal",
    "name": "states",
    "value": "OPEN"
  }
],
v4 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "totalCount",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IssuesAndPullRequestsCountSecondaryQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "IssuesAndPullRequestsCount"
              }
            ],
            "type": "Label",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IssuesAndPullRequestsCountSecondaryQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v3/*: any*/),
                "concreteType": "IssueConnection",
                "kind": "LinkedField",
                "name": "issues",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": "issues(states:\"OPEN\")"
              },
              {
                "alias": null,
                "args": (v3/*: any*/),
                "concreteType": "PullRequestConnection",
                "kind": "LinkedField",
                "name": "pullRequests",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": "pullRequests(states:\"OPEN\")"
              }
            ],
            "type": "Label",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "6a9537e4831ca05890204d59cb7480ef",
    "metadata": {},
    "name": "IssuesAndPullRequestsCountSecondaryQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "5b29bf068c8fc22535058a3f1eba0c50";

export default node;
